import { APICallV2Get } from '../APICall';

export class InvitesInfoApiCall extends APICallV2Get {
    _method = 'folder/invites/info';
}
